import type { PublicTenantConfigResponse } from './core';
import { getSubdomain } from '@/utils/environment';

/**
 * Tenant API endpoints
 */
export const tenantApi = {
  /**
   * Get public tenant configuration (no auth required)
   * Used on login page to apply branding before authentication
   */
  getPublicConfig: async (): Promise<PublicTenantConfigResponse | null> => {
    const subdomain = getSubdomain();
    if (!subdomain || subdomain === 'admin') {
      // No subdomain or admin site - no tenant config needed
      return null;
    }

    const headers: HeadersInit = {
      'Content-Type': 'application/json',
      'X-Tenant-Subdomain': subdomain,
    };

    const response = await fetch('/api/tenant/public', {
      headers,
      credentials: 'include',
    });

    if (!response.ok) {
      const error = await response.json().catch(() => ({ error: 'Request failed' }));
      throw new Error(error.error || `HTTP ${response.status}: ${response.statusText}`);
    }

    return response.json();
  },
};

/**
 * Admin API endpoints for tenant configuration
 */
export const adminApi = {
  // V3.0: OLD tenant settings endpoints removed - use schoolConfigApi instead
  // These endpoints no longer exist on the backend
  // Use schoolConfigApi.update() with JSONB fields instead
};
